import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RootLayout from './layout';
import PresentationPortfolio from './page';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootLayout>
      <PresentationPortfolio />
    </RootLayout>
  </React.StrictMode>
);
